import { createFileRoute } from '@tanstack/react-router';
import { AccessTab } from '@/features/supply-points/components/settings-access-tab/AccessTab';
import { AccessTabSkeleton } from '@/common/components/loading-skeleton/AccessTabSkeleton';

export const Route = createFileRoute('/_authenticated/_supply-point-scope/settings/access')({
  component: AccessTab,
  pendingComponent: AccessTabSkeleton,
});
